import type {
    WebSkillListParams,
    WebSkillListResponse,
    WebSkillDetailItem,
    WebSkillCreateRequest,
    WebSkillCreateData,
    WebSkillEnableData,
    WebSkillDeleteData,
    WebMcpListResponse,
    WebMcpDetailItem,
    WebMcpEnableData,
} from '../types';

export const CustomizeService = Symbol('CustomizeService');

export interface CustomizeService {
    getSkillList(params?: WebSkillListParams): Promise<WebSkillListResponse>;
    getSkillDetail(name: string): Promise<WebSkillDetailItem>;
    createSkill(data: WebSkillCreateRequest): Promise<WebSkillCreateData>;
    enableSkill(name: string): Promise<WebSkillEnableData>;
    disableSkill(name: string): Promise<WebSkillEnableData>;
    deleteSkill(name: string): Promise<WebSkillDeleteData>;

    getMcpList(): Promise<WebMcpListResponse>;
    getMcpDetail(name: string): Promise<WebMcpDetailItem>;
    enableMcp(name: string): Promise<WebMcpEnableData>;
    disableMcp(name: string): Promise<WebMcpEnableData>;
}
